import anime from '@/assets/libs/anime';
import audio from '@/scripts/audio';

export const feedbackInit = (el) => {
  anime.set(el, { scale: 0, rotate: 25 });
};

export const feedbackAnim = (el, answerCorrect = false) => { // eslint-disable-line
  const duration = window.innerWidth < 768 ? 500 : 1000;
  const delay = window.innerWidth < 768 ? 1500 : 2000;

  setTimeout(() => {
    audio.play(answerCorrect ? 'right' : 'wrong');
  }, window.innerWidth < 768 ? 1000 : 0);

  return anime({
    targets: el,
    scale: [
      { value: 0, duration: 0 },
      { value: 1, duration, delay: 1 },
      { value: 0, duration, delay },
    ],
    rotate: [
      { value: 25, duration: 0 },
      { value: 0, duration, delay: 1 },
      { value: -18, duration, delay },
    ],
    duration: 1200,
    delay: window.innerWidth < 768 ? 1000 : 500,
    easing: 'cubicBezier(.5,0,0,1)',
  });
};
